/**
 * WP-STANDARD | STOREFRONT ACQUISITION
 * Destino único de las invitaciones públicas. El frontend de WebProfit usa
 * HashRouter y publica /empecemos como embudo de alta gratuito.
 */
export const WEBPROFIT_FREE_WEBSITE_URL =
  "https://webprofitdesign.com/#/empecemos?entry=storefront-brand";

/**
 * Sólo los datos confirmados del backend pueden habilitar publicidad.
 * trial = prueba gratuita activa; landing_only = suscripción/prueba vencida.
 * En suspensión total sólo se promociona si la causa es el cobro, nunca si
 * un administrador pausó o canceló el proyecto.
 */
export function shouldShowWebProfitPromotion({ access, accessVerified = false, previewRequested = false } = {}) {
  if (!accessVerified || previewRequested || !access) return false;
  const mode = String(access.mode || "").toLowerCase();
  const reason = String(access.reason || "").toLowerCase();
  const billingStatus = String(access.billingStatus || "").toLowerCase();

  if (mode === "landing_only") return true;
  if (mode === "suspended") return reason === "billing_suspended";
  return mode === "full" && billingStatus === "trial" && reason === "trial_active";
}
